'use client';

import { JSFunction } from '@ahm/common-helpers';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useIsMobile } from '@/lib/is-mobile';

export const DetectWebinappContext = createContext(false);

export function useDetectWebinappContext() {
  return useContext(DetectWebinappContext);
}

export const useDetectWebInApp = () => {
  const isMobile = useIsMobile();
  const contextWebinapp = useDetectWebinappContext();
  const [isWebinapp, setIsWebinapp] = useState(contextWebinapp);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Sử dụng localStorage thay vì sessionStorage để tránh mất data khi app chạy ngầm lâu
    const storedWebInApp = localStorage.getItem('isWebinapp') === 'true';
    const urlParams = new URLSearchParams(window.location.search);
    const hasWebInAppParam = urlParams.has('webinapp');

    if ((hasWebInAppParam || storedWebInApp) && isMobile) {
      if (!storedWebInApp) {
        localStorage.setItem('isWebinapp', 'true');
        console.log('🔧 WebInApp detected and saved to localStorage');
      }
      setIsWebinapp(true);

      JSFunction.call({ name: 'hide_toolbar' });

      // Xóa webinapp parameter sau khi đã xử lý để cleanup URL
      if (hasWebInAppParam) {
        setTimeout(() => {
          try {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete('webinapp');
            window.history.replaceState({}, '', currentUrl.toString());
            console.log('🔧 Removed webinapp parameter from URL');
          } catch (error) {
            console.error('Error removing webinapp parameter:', error);
          }
        }, 1000); // 1 second delay
      }
    }
  }, [isMobile]);

  return useMemo(() => isWebinapp, [isWebinapp]);
};
